import axios from 'axios'
import {adminAuthHeader} from '../api/authToken'
const API = axios.create({baseURL: `https://fullrange-api.petrongsoftware.com/api/user`});
// const API = axios.create({baseURL: `http://localhost:8000/api/user`});

export const getCharges = () => API.get('/admin-charges')
export const createCharges = () => API.post('/admin-charge', { headers: adminAuthHeader() })
export const updateCharges = () => API.get('/admin-charge', { headers: adminAuthHeader() })
